import {
  ISortInfo,
  ISortProperty,
  sortRows,
  standardRutinCompare,
  standardRutinGetSortValue,
} from '../../../../../../BaseComponents/Table/Components/SortableTableUtils';
import { IAvenyModelContext } from '../../../../../../Model/ModelContext/ModelContext';
import { IColumnDef } from '../../../../../../Types/ColumnDefType';
import {
  getSortPropertiesFromConfig,
  getSortPropertiesFromColumns,
} from '../../../../_StandardRutin/StandardRutinUtils';
import { tryFindDefaultSort } from '../../../Const/BusinessConfigs';
import { ICollectionDataType } from '../Queries/BusinessCollectionQuery';

export const getInitialSortInfo = (
  associatedCollectionName: string,
  columns: readonly IColumnDef[],
  modelContext: IAvenyModelContext,
  data: ICollectionDataType[] | null
): ISortInfo<ICollectionDataType> => {
  let initialProperties: ISortProperty[] = [];

  const defaultSort = tryFindDefaultSort(associatedCollectionName, '');

  if (defaultSort) {
    initialProperties = getSortPropertiesFromConfig(
      defaultSort,
      columns,
      associatedCollectionName,
      modelContext
    );
  } else {
    initialProperties = getSortPropertiesFromColumns(
      columns,
      associatedCollectionName,
      modelContext
    );
  }

  return {
    rows: sortRows(
      initialProperties,
      data || [],
      standardRutinGetSortValue(associatedCollectionName),
      standardRutinCompare
    ),
    properties: initialProperties,
  };
};
